module.exports = {
      id: "line-arrow-next-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#line-arrow-next",
      toString: function () {
        return this.url;
      }
    }